import { render, staticRenderFns } from "./creatspace.vue?vue&type=template&id=ef8ae18e&scoped=true"
import script from "./creatspace.vue?vue&type=script&lang=js"
export * from "./creatspace.vue?vue&type=script&lang=js"
import style0 from "./creatspace.vue?vue&type=style&index=0&id=ef8ae18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ae18e",
  null
  
)

export default component.exports